import React, { useId, useState } from 'react';
import { homeManufacturers, homePlatformOverviewFigma } from './data';

/** Served from `public/` — not a webpack import */
const industryTabHomeIcon = `${process.env.PUBLIC_URL ?? ''}/images/home/wifi-home-icon.svg`;

function PlatformOverviewCopy() {
  const d = homePlatformOverviewFigma;
  return (
    <div className="io-home-platform-figma__copy-inner">
      <p className="io-home-platform-figma__eyebrow">{d.eyebrow}</p>
      <p className="io-home-platform-figma__lead">{d.lead}</p>
      <ul className="io-home-platform-figma__feature-list">
        {d.features.map((f) => (
          <li key={f.id} className="io-home-platform-figma__feature-card">
            {f.title}
          </li>
        ))}
      </ul>
    </div>
  );
}

/**
 * Figma node 1001:431 — two split rows (phone + copy, copy + dashboard) + Trusted by manufacturers.
 */
export const HomePlatformAccordion: React.FC = () => {
  const d = homePlatformOverviewFigma;
  const baseId = useId();
  const [active, setActive] = useState(homeManufacturers.tabs[0].id);
  const tab = homeManufacturers.tabs.find((t) => t.id === active) ?? homeManufacturers.tabs[0];

  return (
    <section className="io-home-platform-figma" aria-labelledby="io-home-platform-figma-trust-title">
      <div className="io-home-platform-figma__row io-home-platform-figma__row--top">
        <div className="io-home-platform-figma__visual io-home-platform-figma__visual--phone">
          <div className="io-home-platform-figma__phone-crop">
            <img
              src={d.phoneImage}
              alt={d.phoneImageAlt}
              className="io-home-platform-figma__phone-img"
              width={372}
              height={527}
              loading="lazy"
            />
          </div>
        </div>
        <div className="io-home-platform-figma__column io-home-platform-figma__column--muted">
          <PlatformOverviewCopy />
        </div>
      </div>

      <div className="io-home-platform-figma__row io-home-platform-figma__row--bottom">
        <div className="io-home-platform-figma__column io-home-platform-figma__column--muted">
          <PlatformOverviewCopy />
        </div>
        <div className="io-home-platform-figma__visual io-home-platform-figma__visual--lime">
          <img
            src={d.dashboardImage}
            alt={d.dashboardImageAlt}
            className="io-home-platform-figma__dash-img"
            loading="lazy"
          />
        </div>
      </div>

      <div className="io-home-platform-figma__trust">
        <div className="io-home-platform-figma__trust-head">
          <h2 id="io-home-platform-figma-trust-title" className="io-home-platform-figma__trust-title">
            {homeManufacturers.title}
          </h2>
          <p className="io-home-platform-figma__trust-sub">{homeManufacturers.subtitle}</p>
        </div>
        <div className="io-home-platform-figma__tabs" role="tablist" aria-label="Industry segments">
          {homeManufacturers.tabs.map((t) => {
            const tid = `${baseId}-${t.id}`;
            const selected = t.id === active;
            return (
              <button
                key={t.id}
                type="button"
                role="tab"
                id={`${tid}-tab`}
                aria-selected={selected}
                aria-controls={`${tid}-panel`}
                tabIndex={selected ? 0 : -1}
                className={`io-home-platform-figma__tab${selected ? ' io-home-platform-figma__tab--active' : ''}`}
                onClick={() => setActive(t.id)}
              >
                <img
                  src={industryTabHomeIcon}
                  alt=""
                  className="io-home-platform-figma__tab-icon"
                  width={24}
                  height={24}
                  aria-hidden
                />
                {t.label}
              </button>
            );
          })}
        </div>
        <div
          role="tabpanel"
          id={`${baseId}-${tab.id}-panel`}
          aria-labelledby={`${baseId}-${tab.id}-tab`}
          className="io-home-platform-figma__tabpanel"
        >
          {/* <p>{tab.body}</p> */}
        </div>
      </div>
    </section>
  );
};
